import "core-js/modules/es.array.join";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { activityTimeManager } from "@/api/gmToolNew/gmToolNew";
import addMidifyTime from "./components/addMidifyTime";
import addResetTime from "./components/addResetTime";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
export default {
  name: "unifiedServiceManage",
  components: {
    addMidifyTime: addMidifyTime,
    addResetTime: addResetTime
  },
  mixins: [gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      dialog: false,
      total: 0,
      list: [],
      paramsData: {}
    };
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      if (!this.paramsData.server_id.length) {
        this.$message.error(this.$t('pleaseSelectServer'));
        return;
      }

      if (!this.paramsData.actID) {
        this.$message.error(this.$t('pleaseEnterActivityId'));
        return;
      }

      this.reqLoading = true;
      var paramsData = JSON.parse(JSON.stringify(this.paramsData));
      paramsData.server_id = paramsData.server_id.join(",");
      activityTimeManager(paramsData).then(function (res) {
        if (res.status == 200) {
          _this.list = [res.data];
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    }
  }
};